const {
  adminUrl,
  ajaxUrl,
  didDisconnect,
  env,
  formsScript,
  formsScriptPayload,
  hubspotBaseUrl,
  leadinPluginVersion,
  loginUrl,
  pluginPath,
  nonce,
  plugins,
  phpVersion,
  portalId,
  portalEmail,
  iframeUrl,
  accountName,
  routes,
  theme,
  wpVersion,
  signupUrl,
  portalDomain,
  dismissedReview,
} = window.leadinConfig;

const i18n = window.leadinI18n;

export {
  adminUrl,
  ajaxUrl,
  didDisconnect,
  env,
  formsScript,
  formsScriptPayload,
  hubspotBaseUrl,
  i18n,
  leadinPluginVersion,
  loginUrl,
  pluginPath,
  nonce,
  plugins,
  phpVersion,
  portalId,
  portalEmail,
  iframeUrl,
  accountName,
  routes,
  theme,
  wpVersion,
  signupUrl,
  portalDomain,
  dismissedReview,
};
